import { render } from "./UserRemovalConfirmationDialog.vue?vue&type=template&id=3e38ee82"
import script from "./UserRemovalConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./UserRemovalConfirmationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__